import React from 'react'
import {
    Box, Card, CardContent, Typography, Button, Grid
} from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'

/**
 * Inline prompt banner shown at the top of the billing page when the provider
 * still needs to set up essentials (delivery method, payment method).
 */
function BillingSetupPrompts({ missingDeliveryMethod, missingPaymentMethod, onSetupDelivery, onSetupPayment }) {
    if (!missingDeliveryMethod && !missingPaymentMethod) return null

    const items = []
    if (missingPaymentMethod) {
        items.push({
            key: 'payment',
            title: 'Add a payment method',
            body: 'We need a card on file to bill you for delivered leads.',
            cta: 'Add card',
            onClick: onSetupPayment
        })
    }
    if (missingDeliveryMethod) {
        items.push({
            key: 'delivery',
            title: 'Set up your lead delivery method',
            body: 'Choose how you want us to deliver leads (email or CRM).',
            cta: 'Set up delivery',
            onClick: onSetupDelivery
        })
    }

    return (
        <Card
            style={{
                borderLeft: '4px solid #f5a623',
                marginBottom: '1.5rem'
            }}
        >
            <CardContent>
                <Box display='flex' alignItems='center' mb={1} style={{ gap: 8 }}>
                    <WarningIcon style={{ color: '#f5a623' }} />
                    <Typography variant='h4' style={{ marginBottom: 0 }}>
                        Finish setting up your account
                    </Typography>
                </Box>
                <Grid container spacing={2}>
                    {items.map(item => (
                        <Grid item xs={12} sm={items.length > 1 ? 6 : 12} key={item.key}>
                            <Box
                                p={2}
                                display='flex'
                                alignItems='center'
                                justifyContent='space-between'
                                style={{
                                    backgroundColor: '#fffaf0',
                                    borderRadius: 6,
                                    border: '1px solid #fceabb',
                                    gap: 12
                                }}
                            >
                                <Box>
                                    <Typography variant='subtitle2' style={{ fontWeight: 600 }}>
                                        {item.title}
                                    </Typography>
                                    <Typography variant='body2' style={{ color: '#525f7f' }}>
                                        {item.body}
                                    </Typography>
                                </Box>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    size='small'
                                    onClick={item.onClick}
                                >
                                    {item.cta}
                                </Button>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </Card>
    )
}

export default BillingSetupPrompts
